import {Component} from "@angular/core";
import {provideEntityModel, provideSearchModel} from "@fedeltapointofsale/data-client";
import {ScreenLayoutSearchModel} from "../screen-layout-search.model";
import {ScreenLayoutEntityModel} from "../screen-layout-entity.model";
import {AbstractSearchPage} from "../../../framework/entity/search/search-page/abstract-search-page";
import {SellableIconService} from "../../../catalogue/sellable/sellable-icon.service";

@Component({
    selector: "wbo-screen-layout-search-page",
    templateUrl: "./screen-layout-search-page.component.html",
    providers: [provideSearchModel(ScreenLayoutSearchModel), provideEntityModel(ScreenLayoutEntityModel), SellableIconService]
})
export class ScreenLayoutSearchPageComponent extends AbstractSearchPage {
    constructor() {
        super();
    }
}
